export default __webpack_public_path__ + "static/media/service_4.8aef36fe.jpeg";